'use strict';

var _ = require('lodash');
var DemandPostingBreakdownModalDataProviderService = function DemandPostingBreakdownModalDataProviderService(dataRetrieverService, applyOperationService) {
  function loadDataFromGrid(gridParams) {
    return dataRetrieverService.getDataRetriever(gridParams.screen, gridParams.mode).retrieveComponentData(gridParams.gridId);
  }
  function aggregatePOS(items, dimension) {
    return _.reduce(items, function (result, item) {
      result.departureDateMoment = item.departureDateMoment;
      result.marketDemandId = item.marketDemandId;
      result.classGroup = item.classGroup;
      if (!dimension || dimension === 'regular') {
        result.demand += _.isFinite(item.regularRemainingDemandFC) ? item.regularRemainingDemandFC : 0;
        result.effectiveDemand += _.isFinite(item.effectiveRegularRemainingDemandFC) ? item.effectiveRegularRemainingDemandFC : 0;
      } else {
        result.demand += _.isFinite(item.mappedRemainingDemandFC) ? item.mappedRemainingDemandFC : 0;
        result.effectiveDemand += _.isFinite(item.effectiveMappedRemainingDemandFC) ? item.effectiveMappedRemainingDemandFC : 0;
      }
      return result;
    }, {
      demand: 0,
      effectiveDemand: 0
    });
  }
  function pickFields(item) {
    return _.pick(item, ['marketDemandId', 'entryKey', 'classGroup', 'posName', 'regularRemainingDemandFC', 'userTypeRegularRemainingDemandFC', 'userValueRegularRemainingDemandFC', 'effectiveRegularRemainingDemandFC', 'mappedRemainingDemandFC', 'userTypeMappedRemainingDemandFC', 'userValueMappedRemainingDemandFC', 'effectiveMappedRemainingDemandFC', 'departureDateMoment']);
  }
  function transformGridData(gridData, dimension, classGrp) {
    return _.chain(gridData).filter({
      classGroup: classGrp
    }).map(pickFields).groupBy('marketDemandId').map(function (item) {
      return aggregatePOS(item, dimension);
    }).sortBy('marketDemandId').map(function (item) {
      var tile = {
        effective: item.effectiveDemand
      };
      var model = !_.isNaN(item.demand) ? item.demand : 0;
      var effective = !_.isNaN(item.effectiveDemand) ? item.effectiveDemand : 0;
      var change = (effective - model) / model * 100;
      return {
        classGroup: item.classGroup,
        date: item.departureDateMoment,
        model: model,
        effective: effective,
        change: change,
        tiles: item.effectiveDemand < item.demand ? [tile] : [],
        visible: true
      };
    }).value();
  }
  function getData(operationData, gridParams, dimension, applyOperation) {
    return loadDataFromGrid(gridParams).then(function (gridData) {
      var operationResult = gridData;
      if (applyOperation) {
        operationResult = applyOperationService.applyOperation(gridData, gridParams, dimension, operationData);
      }
      return {
        sourceData: transformGridData(operationResult, dimension, operationData.source),
        targetData: transformGridData(operationResult, dimension, operationData.target)
      };
    });
  }
  return {
    getData: getData,
    aggregatePOS: aggregatePOS,
    loadDataFromGrid: loadDataFromGrid,
    transformGridData: transformGridData
  };
};
DemandPostingBreakdownModalDataProviderService.$inject = ['DataRetrieverService', 'DemandPostingApplyOperationService'];
module.exports = DemandPostingBreakdownModalDataProviderService;